var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookHomeColord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9875_6017)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0059 0C10.491 0 8.29324 0.00775548 7.86602 0.0431999C6.32386 0.171426 5.36423 0.414312 4.31875 0.934957C3.51307 1.33516 2.87764 1.79904 2.25053 2.44931C1.10844 3.6352 0.416261 5.09415 0.165687 6.82839C0.04387 7.67031 0.00842533 7.84201 0.00122759 12.1424C-0.00153449 13.5759 0.00122759 15.4625 0.00122759 17.9929C0.00122759 25.5037 0.00952739 27.6999 0.0455297 28.1264C0.170123 29.6275 0.405457 30.5719 0.903829 31.6049C1.85627 33.5823 3.6753 35.0667 5.81829 35.6206C6.56031 35.8117 7.37984 35.9169 8.43195 35.9668C8.87772 35.9862 13.4212 36 17.9674 36C22.5136 36 27.0598 35.9945 27.4945 35.9723C28.7128 35.915 29.4202 35.82 30.2023 35.6178C32.3592 35.0612 34.145 33.5989 35.1168 31.5938C35.6055 30.5857 35.8533 29.6053 35.9654 28.1826C35.9898 27.8725 36 22.927 36 17.9882C36 13.0486 35.9889 8.11231 35.9646 7.80213C35.851 6.35647 35.6032 5.3844 35.0988 4.35691C34.6849 3.51583 34.2253 2.88771 33.558 2.24549C32.3672 1.10778 30.9108 0.415414 29.1754 0.165058C28.3345 0.0434722 28.167 0.00746986 23.8645 0H18.0059Z",
    fill: "url(#paint0_radial_9875_6017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0059 0C10.491 0 8.29324 0.00775548 7.86602 0.0431999C6.32386 0.171426 5.36423 0.414312 4.31875 0.934957C3.51307 1.33516 2.87764 1.79904 2.25053 2.44931C1.10844 3.6352 0.416261 5.09415 0.165687 6.82839C0.04387 7.67031 0.00842533 7.84201 0.00122759 12.1424C-0.00153449 13.5759 0.00122759 15.4625 0.00122759 17.9929C0.00122759 25.5037 0.00952739 27.6999 0.0455297 28.1264C0.170123 29.6275 0.405457 30.5719 0.903829 31.6049C1.85627 33.5823 3.6753 35.0667 5.81829 35.6206C6.56031 35.8117 7.37984 35.9169 8.43195 35.9668C8.87772 35.9862 13.4212 36 17.9674 36C22.5136 36 27.0598 35.9945 27.4945 35.9723C28.7128 35.915 29.4202 35.82 30.2023 35.6178C32.3592 35.0612 34.145 33.5989 35.1168 31.5938C35.6055 30.5857 35.8533 29.6053 35.9654 28.1826C35.9898 27.8725 36 22.927 36 17.9882C36 13.0486 35.9889 8.11231 35.9646 7.80213C35.851 6.35647 35.6032 5.3844 35.0988 4.35691C34.6849 3.51583 34.2253 2.88771 33.558 2.24549C32.3672 1.10778 30.9108 0.415414 29.1754 0.165058C28.3345 0.0434722 28.167 0.00746986 23.8645 0H18.0059Z",
    fill: "url(#paint1_radial_9875_6017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0059 0C10.491 0 8.29324 0.00775548 7.86602 0.0431999C6.32386 0.171426 5.36423 0.414312 4.31875 0.934957C3.51307 1.33516 2.87764 1.79904 2.25053 2.44931C1.10844 3.6352 0.416261 5.09415 0.165687 6.82839C0.04387 7.67031 0.00842533 7.84201 0.00122759 12.1424C-0.00153449 13.5759 0.00122759 15.4625 0.00122759 17.9929C0.00122759 25.5037 0.00952739 27.6999 0.0455297 28.1264C0.170123 29.6275 0.405457 30.5719 0.903829 31.6049C1.85627 33.5823 3.6753 35.0667 5.81829 35.6206C6.56031 35.8117 7.37984 35.9169 8.43195 35.9668C8.87772 35.9862 13.4212 36 17.9674 36C22.5136 36 27.0598 35.9945 27.4945 35.9723C28.7128 35.915 29.4202 35.82 30.2023 35.6178C32.3592 35.0612 34.145 33.5989 35.1168 31.5938C35.6055 30.5857 35.8533 29.6053 35.9654 28.1826C35.9898 27.8725 36 22.927 36 17.9882C36 13.0486 35.9889 8.11231 35.9646 7.80213C35.851 6.35647 35.6032 5.3844 35.0988 4.35691C34.6849 3.51583 34.2253 2.88771 33.558 2.24549C32.3672 1.10778 30.9108 0.415414 29.1754 0.165058C28.3345 0.0434722 28.167 0.00746986 23.8645 0H18.0059Z",
    fill: "url(#paint2_radial_9875_6017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0059 0C10.491 0 8.29324 0.00775548 7.86602 0.0431999C6.32386 0.171426 5.36423 0.414312 4.31875 0.934957C3.51307 1.33516 2.87764 1.79904 2.25053 2.44931C1.10844 3.6352 0.416261 5.09415 0.165687 6.82839C0.04387 7.67031 0.00842533 7.84201 0.00122759 12.1424C-0.00153449 13.5759 0.00122759 15.4625 0.00122759 17.9929C0.00122759 25.5037 0.00952739 27.6999 0.0455297 28.1264C0.170123 29.6275 0.405457 30.5719 0.903829 31.6049C1.85627 33.5823 3.6753 35.0667 5.81829 35.6206C6.56031 35.8117 7.37984 35.9169 8.43195 35.9668C8.87772 35.9862 13.4212 36 17.9674 36C22.5136 36 27.0598 35.9945 27.4945 35.9723C28.7128 35.915 29.4202 35.82 30.2023 35.6178C32.3592 35.0612 34.145 33.5989 35.1168 31.5938C35.6055 30.5857 35.8533 29.6053 35.9654 28.1826C35.9898 27.8725 36 22.927 36 17.9882C36 13.0486 35.9889 8.11231 35.9646 7.80213C35.851 6.35647 35.6032 5.3844 35.0988 4.35691C34.6849 3.51583 34.2253 2.88771 33.558 2.24549C32.3672 1.10778 30.9108 0.415414 29.1754 0.165058C28.3345 0.0434722 28.167 0.00746986 23.8645 0H18.0059Z",
    fill: "url(#paint3_radial_9875_6017)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint4_linear_9875_6017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 19.1167H22.0476L23 15.25H19.6667V13.3167C19.6667 12.321 19.6667 11.3833 21.5714 11.3833H23V8.13533C22.6895 8.09377 21.5171 8 20.279 8C17.6933 8 15.8571 9.60177 15.8571 12.5433V15.25H13V19.1167H15.8571V27.3333H19.6667V19.1167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9875_6017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8376 16.8736) rotate(164.25) scale(23.002 16.5718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC01D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9875_6017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.56223 38.7727) rotate(-90) scale(28.7359 30.4882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5672,
    stopColor: "#FE4A05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6942,
    stopColor: "#FF0F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE0657",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9875_6017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.9097 35.4923) rotate(-59.8703) scale(11.8825 15.4697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9875_6017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.88443 1.46591) rotate(164.274) scale(22.7468 7.74982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#780CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#820BFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9875_6017",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DAAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0566DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9875_6017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookHomeColord);
export default __webpack_public_path__ + "static/media/facebook-home-colord.12959fb99c060c00b51570418b431bb7.svg";
export { ForwardRef as ReactComponent };